import React from "react";
import { Activity, LineChart } from "lucide-react";
import type { DashTab } from "../types";
import { useLanguage } from "@/i18n/LanguageContext";

export const TabBar: React.FC<{ activeTab: DashTab; onChange: (tab: DashTab) => void }> = React.memo(({ activeTab, onChange }) => {
  const { t } = useLanguage();
  const tabs: Array<{ id: DashTab; label: string; icon: React.ComponentType<{ className?: string }> }> = [
    { id: "combined", label: t("dash.tab.combined"), icon: LineChart },
    { id: "new-indicators", label: t("dash.tab.newIndicators"), icon: Activity },
  ];

  return (
    <section className="card p-1">
      <div className="grid gap-1 sm:grid-cols-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onChange(tab.id)}
              className={`flex h-9 items-center justify-center gap-2 rounded-xl px-3 text-[11px] font-medium transition-all ${
                active
                  ? "bg-primary-500 text-white shadow-soft"
                  : "bg-primary-50/60 text-primary-600 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              <Icon className={`h-3.5 w-3.5 ${active ? "text-white" : "text-primary-400"}`} />
              {tab.label}
            </button>
          );
        })}
      </div>
    </section>
  );
});
TabBar.displayName = "TabBar";
